import React from 'react';
import { connect } from 'react-redux';

import DataTable from '../DataTable/index.jsx';

import Columns from './Columns/index.jsx';

import { fetch as fetchNFTs, isLoading as isNFTLoading, getAllCollections } from '../../Store/nfts.js';
import { fetch as fetchUserPreferences, getUserPreferences, hideCollectionTableColumn, setCollectionTableSort, showCollectionTableColumn } from '../../Store/user-preferences.js';


var NFTCollectionList = function(props) {
  return (
    <DataTable
      loading={props.loading}
      fetch={props.fetch}
      columns={props.columns}
      rows={props.collections}
      columnVisibility={props.collectionTableColumns}
      hideColumn={props.hideColumn}
      showColumn={props.showColumn}
      sort={props.sort}
      setSort={props.setSort}
    />
  );
}


var mapStateToProps = function(state, ownProps) {
  var userPreferences = getUserPreferences(state);
  var collections = getAllCollections(state);

  var additionalProps = {};

  additionalProps.loading = isNFTLoading(state);
  additionalProps.columns = Columns();

  additionalProps.collectionTableColumns = userPreferences.collectionTableColumns;
  additionalProps.sort = userPreferences.collectionTableSort;
  additionalProps.collections = collections;


  return additionalProps;
};

var mapDispatchToProps = function(dispatch, ownProps) {
  return {
    fetch: function() {
      dispatch(fetchUserPreferences());
      dispatch(fetchNFTs());
    },
    hideColumn: function(column) {
      dispatch(hideCollectionTableColumn(column));
    },
    setSort: function(column) {
      dispatch(setCollectionTableSort(column));
    },
    showColumn: function(column) {
      dispatch(showCollectionTableColumn(column));
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(NFTCollectionList);

